import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import LandingPage from './Components/LandingPage.js';
import FAQs from './Components/FAQs.js';
import Regulators from './Components/Regulators';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App poppins">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/regulatory-dashboard" element={<Regulators />} />
          <Route path="/faqs" element={<FAQs />} />
          
          {/* Add the Docs route here */}
          <Route
            path="/docs"
            element={
              <iframe
                src="/build/index.html"
                style={{ width: '100%', height: '100vh', border: 'none' }}
                title="SurferMonkey Documentation"
              />
            }
          />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
